import { render, staticRenderFns } from "./TheShop.vue?vue&type=template&id=7ec5ff6e&scoped=true"
import script from "./TheShop.vue?vue&type=script&lang=js"
export * from "./TheShop.vue?vue&type=script&lang=js"
import style0 from "./TheShop.vue?vue&type=style&index=0&id=7ec5ff6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec5ff6e",
  null
  
)

export default component.exports